export default __webpack_public_path__ + "static/sewing-8856bac8eccfa51bc85f69e827bc0a24.png";